import { useRequest } from "hooks/useRequest";

export const useCacheRequester = () => {
	const request = useRequest("cache");

	return {
		runCache: () => {
			return request.POST("warmup", {});
		},
	};
};
